export function pointerMovedEnough(
  startX: number,
  startY: number,
  currentX: number,
  currentY: number,
  threshold = 8,
): boolean {
  const deltaX = currentX - startX;
  const deltaY = currentY - startY;
  return deltaX * deltaX + deltaY * deltaY >= threshold * threshold;
}

export function edgeScrollDelta(
  clientX: number,
  left: number,
  right: number,
  threshold = 48,
  maxStep = 18,
): number {
  if (right <= left || threshold <= 0 || maxStep <= 0) return 0;
  if (clientX < left + threshold) {
    const ratio = Math.min(1, Math.max(0, (left + threshold - clientX) / threshold));
    return -Math.max(1, Math.round(maxStep * ratio));
  }
  if (clientX > right - threshold) {
    const ratio = Math.min(1, Math.max(0, (clientX - (right - threshold)) / threshold));
    return Math.max(1, Math.round(maxStep * ratio));
  }
  return 0;
}
